import { ALLOCATION_WEIGHTED_SHARE_VALUES_SPREADSHEET_COLUMN_KEY_PREFIX } from 'pages/ValuationsAllocation/common/constants/weightedShareValues';
import { generateColumnKey, getNumberValue, getObjectValue, getStringValue } from 'utilities';
import { CreateColumns, WeightedShareValuesColumn, WeightedShareValuesColumnCellData } from './types';

const createColumns: CreateColumns = params => {
  const { shareValues } = params;

  // Weighted Value per Share
  const weightedValuePerShare = shareValues?.reduce((accumulator, current) => {
    const { is_custom_security: isCustomSecurity, security, securityId, entity } = getObjectValue(current);

    return {
      ...accumulator,
      [generateColumnKey({
        id: `${securityId ?? security}_${entity.id}`,
        name: getStringValue(security),
        prefix: ALLOCATION_WEIGHTED_SHARE_VALUES_SPREADSHEET_COLUMN_KEY_PREFIX,
      })]: {
        isCustomSecurity,
        security: getStringValue(security),
        value: null,
      } as WeightedShareValuesColumnCellData,
    };
  }, {}) as WeightedShareValuesColumn;

  // # of Shares
  const numberOfShares = shareValues?.reduce((accumulator, current) => {
    const { is_custom_security: isCustomSecurity, security, shares, securityId, entity } = getObjectValue(current);

    return {
      ...accumulator,
      [generateColumnKey({
        id: `${securityId ?? security}_${entity.id}`,
        name: getStringValue(security),
        prefix: ALLOCATION_WEIGHTED_SHARE_VALUES_SPREADSHEET_COLUMN_KEY_PREFIX,
      })]: {
        isCustomSecurity,
        security: getStringValue(security),
        value: getNumberValue(shares),
      } as WeightedShareValuesColumnCellData,
    };
  }, {}) as WeightedShareValuesColumn;

  // Value
  const value = shareValues?.reduce((accumulator, current) => {
    const {
      is_custom_security: isCustomSecurity,
      security,
      unrealized_value: unrealizedValue,
      securityId,
      entity,
      loan_value: loanValue,
    } = getObjectValue(current);

    return {
      ...accumulator,
      [generateColumnKey({
        id: `${securityId ?? security}_${entity.id}`,
        name: getStringValue(security),
        prefix: ALLOCATION_WEIGHTED_SHARE_VALUES_SPREADSHEET_COLUMN_KEY_PREFIX,
      })]: {
        isCustomSecurity,
        security: getStringValue(security),
        value: getNumberValue(unrealizedValue) || getNumberValue(loanValue),
      } as WeightedShareValuesColumnCellData,
    };
  }, {}) as WeightedShareValuesColumn;

  // MOIC
  const MOIC = shareValues?.reduce((accumulator, current) => {
    const {
      invested_capital: investedCapital,
      is_custom_security: isCustomSecurity,
      security,
      securityId,
      entity,
    } = getObjectValue(current);

    return {
      ...accumulator,
      [generateColumnKey({
        id: `${securityId ?? security}_${entity.id}`,
        name: getStringValue(security),
        prefix: ALLOCATION_WEIGHTED_SHARE_VALUES_SPREADSHEET_COLUMN_KEY_PREFIX,
      })]: {
        investedCapital: getNumberValue(investedCapital),
        isCustomSecurity,
        security: getStringValue(security),
        value: null,
      } as WeightedShareValuesColumnCellData,
    };
  }, {}) as WeightedShareValuesColumn;

  return [weightedValuePerShare, numberOfShares, value, MOIC];
};

export default createColumns;
